import BucketApiRequest from "./BucketApiRequest";
import { GET_OCCUPATION_CODES } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetOccupationCodes extends BucketApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return GET_OCCUPATION_CODES;
  };

  getBody = () => {
    return this.body;
  };
}
